import React from "react";
import { StatsTableCell } from "./audiences.style";

const AudienceLine = ({ fbAudience }) => {
    return (
        <>
            <StatsTableCell>{fbAudience.name}</StatsTableCell>
            <StatsTableCell>{fbAudience.size ? fbAudience.size : 0}</StatsTableCell>
            <StatsTableCell status={fbAudience.status}>
                <span>{fbAudience.status}</span>
            </StatsTableCell>
        </>
    );
};
export default AudienceLine;
